const phrase = "THIRTY MEETINGS · THIRTY DAYS · ONE REVENUE ENGINE ·";
const items = new Array(6).fill(phrase);

export default function Marquee() {
    return (
        <section
            data-testid="marquee-section"
            className="rule-top rule-bottom overflow-hidden py-8 md:py-10 bg-[#050505]"
            aria-label="Editorial marquee"
        >
            <div className="marquee-track flex whitespace-nowrap will-change-transform">
                {[...items, ...items].map((t, i) => (
                    <span
                        key={i}
                        className="font-editorial italic text-white/90 text-[8vw] md:text-[5.5vw] px-8"
                    >
                        {t}
                    </span>
                ))}
            </div>
        </section>
    );
}
